const HealthCheck = () => {
  return <div className="h-100 w-100 d-flex justify-content-center align-items-center"><p className="text-center">Healthy</p></div>
}

export default HealthCheck
